import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { ESportsbookLayoutTypes } from 'interfaces/sportsbook-configs';
import { AdvancedMarketsFilterSkeleton } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedEventsLayout/__partials/AdvancedMarketsFilter/Skeleton';
import { AdvancedGamesFilteredByCompetitionsSkeleton } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedGamesByCompetitions/Skeleton';
import { AdvancedMatchCardSkeleton } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedMatchCard/Skeleton';
import { MatchCardInlineUSASkeleton } from 'components/Shared/MatchCardInlineUSA/__partials/Skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import './index.less';

const SKELETON_COUNT = 3;

export const FavoriteTeamBodySkeleton = () => {
  const { spbLayoutType } = useSportsbookConfigs();

  if (isMobile()) {
    return (
      <>
        <div
          className={
            spbLayoutType === ESportsbookLayoutTypes.AMERICAN
              ? 'favoriteTeamsBody--sportHeader--usa'
              : 'favoriteTeamsBody--sportHeader'
          }
        >
          <div className="favoriteTeamsBody--sportHeader--icon">
            <Skeleton.Avatar size={24} active />
          </div>
          <div className="favoriteTeamsBody--sportHeader--name">
            <Skeleton.Button active style={{ minWidth: 160, height: 24 }} />
          </div>
        </div>

        {spbLayoutType === ESportsbookLayoutTypes.AMERICAN ? (
          <>
            <div className="favoriteTeamsBody--sportHeader--usa">
              <Skeleton.Button active style={{ minWidth: 260, height: 24 }} />
            </div>
            <MatchCardInlineUSASkeleton />
          </>
        ) : (
          <AdvancedGamesFilteredByCompetitionsSkeleton
            showMarketFilterSkeleton
          />
        )}
      </>
    );
  }

  return (
    <div style={{ marginTop: 8 }}>
      <AdvancedMarketsFilterSkeleton addSportSectionInHeader />

      {createArray(SKELETON_COUNT).map((_, index) => (
        <AdvancedMatchCardSkeleton key={index} />
      ))}
    </div>
  );
};
